import { Icon, LinkButton, Show } from '@homebotapp/hb-react-component-catalog'
import { Link as ReactRouterLink } from 'react-router-dom'
import { PATH_HELPERS } from '../../../constants/navigation'
import { constructFiltersAndOmitEmpty } from '../../../helpers/listings/filters'
import { SavedSearchModel } from '../../../types/savedSearches'
import { HOME_SEARCH_SAVED_SEARCH_PAGE_SEE_MORE_LISTINGS } from '../../../constants/tracking/trackingEventLocations/homeSearchTrackingEventLocation'
import { defineMessages, FormattedMessage, useIntl } from 'react-intl'
import { SeeAllListingsDisabledButton } from './SeeAllListingsDisabledButton'
import { ListingCompact } from '../../../api/gqlaxy/gql/generated/graphql'
import qs from 'qs'
import { useSelector } from 'react-redux'
import { selectCustomerId } from '../../../store/selectors/customerProfile'
import { useRecoilState } from 'recoil'
import { currentSearchLocation } from '../GoogleAutoComplete/state/currentSearchLocation'
import { homeSearchMapState } from '../Listings/ListingsMap/state/homeSearchMapState'

const MSG = defineMessages({
  seeAllHomes: {
    id: 'HomeSearch.savedSearches.seeAllHomes',
    defaultMessage: 'See all homes'
  },
  noHomes: {
    id: 'HomeSearch.savedSearches.noHomes',
    defaultMessage: 'No homes'
  }
})

interface SeeAllListingsButtonProps {
  customerId: string
  savedSearch: SavedSearchModel
  listingsData: ListingCompact[]
}

export const SeeAllListingsButton = ({ customerId, savedSearch, listingsData }: SeeAllListingsButtonProps) => {
  const intl = useIntl()
  const customerProfileId = useSelector(selectCustomerId)
  const linkIsDisabled = !listingsData || listingsData.length === 0
  const [searchLocation, setSearchLocation] = useRecoilState(currentSearchLocation)
  const [mapState, setMapState] = useRecoilState(homeSearchMapState)

  if (linkIsDisabled) {
    return <SeeAllListingsDisabledButton />
  }

  const getSeeMoreResultsUrl = () => {
    // clear the search location and mapstate from localStorage so it doesn't interfere with the new search
    setSearchLocation(undefined)
    setMapState(undefined)

    if (!customerProfileId) {
      return '/'
    }
    const additionalFilters = constructFiltersAndOmitEmpty(savedSearch?.filters)
    let additional = qs.stringify(additionalFilters)
    additional = additional ? `&${additional}` : ''

    if (savedSearch?.searchArea.placeIdInput?.placeId) {
      const url = `/home-search/${customerProfileId}/listings?place_id=${savedSearch.searchArea.placeIdInput.placeId}&from=saved_search_place_id${additional}`
      return url
    }

    if (
      savedSearch?.searchArea.boundingBox?.bottomRight.latitude &&
      savedSearch?.searchArea.boundingBox?.bottomRight.longitude &&
      savedSearch?.searchArea.boundingBox?.topLeft.latitude &&
      savedSearch?.searchArea.boundingBox?.topLeft.longitude
    ) {
      const url =
        `/home-search/${customerProfileId}/listings?` +
        `bottomRightLat=${savedSearch.searchArea.boundingBox.bottomRight.latitude}&` +
        `bottomRightLong=${savedSearch.searchArea.boundingBox.bottomRight.longitude}&` +
        `topLeftLat=${savedSearch.searchArea.boundingBox.topLeft.latitude}&` +
        `topLeftLong=${savedSearch.searchArea.boundingBox.topLeft.longitude}` +
        `&from=saved_search_bounding_box` +
        `${additional}`
      return url
    }

    // fallback, should never happen
    return '/'
  }

  return (
    <LinkButton
      rightIcon={
        <Show above='xl'>
          <Icon name='circle-arrow-right-bts' width='12px' height='12px' />
        </Show>
      }
      size='sm'
      colorScheme='primary'
      // hack because link hover state blue was hard to see against the blue background. DS will fix this but in the meantime we need to override the hover color+bg
      _hover={{ color: '#000', backgroundColor: 'var(--hb-colors-blue-800)' }}
      ml={[0, 0, 0, 1, 2]}
      mb={2}
      as={ReactRouterLink}
      to={getSeeMoreResultsUrl()}
      // onClick={() => setSearchLocation(undefined)}
      tracking={{
        guid: '4UhKDzHURo1SdiwEqafasX',
        ui_context: HOME_SEARCH_SAVED_SEARCH_PAGE_SEE_MORE_LISTINGS,
        descriptor: 'See more listings button from saved search page'
      }}
    >
      {intl.formatMessage(MSG.seeAllHomes)}
    </LinkButton>
  )
}
